/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 12L22 12M22 12L18 8M22 12L18 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 16.0005L13.9999 16.5V16.5C14 17.896 14 18.594 13.8276 19.1619C13.4398 20.4401 12.4396 21.4403 11.1614 21.8281C10.5935 22.0005 9.89549 22.0005 8.49951 22.0005H7.99997C6.13623 22.0005 5.20436 22.0005 4.46929 21.696C3.48916 21.29 2.71045 20.5113 2.30447 19.5312C2 18.7961 2 17.8643 2 16.0005L2 8.00049C2 6.13672 2 5.20484 2.30448 4.46975C2.71046 3.48964 3.48916 2.71095 4.46927 2.30497C5.20435 2.00049 6.13624 2.00049 8 2.00049L8.50049 2.00049C9.8956 2.00049 10.5931 2.00049 11.1608 2.17262C12.4395 2.56037 13.4401 3.56101 13.8279 4.83972C14 5.40734 14 6.10489 14 7.5V7.5L14 8.00049"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="12"
				height="20"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M14 16.0005L13.9999 16.5V16.5C14 17.896 14 18.594 13.8276 19.1619C13.4398 20.4401 12.4396 21.4403 11.1614 21.8281C10.5935 22.0005 9.89549 22.0005 8.49951 22.0005H7.99997C6.13623 22.0005 5.20436 22.0005 4.46929 21.696C3.48916 21.29 2.71045 20.5113 2.30447 19.5312C2 18.7961 2 17.8643 2 16.0005L2 8.00049C2 6.13672 2 5.20484 2.30448 4.46975C2.71046 3.48964 3.48916 2.71095 4.46927 2.30497C5.20435 2.00049 6.13624 2.00049 8 2.00049L8.50049 2.00049C9.8956 2.00049 10.5931 2.00049 11.1608 2.17262C12.4395 2.56037 13.4401 3.56101 13.8279 4.83972C14 5.40734 14 6.10489 14 7.5V7.5L14 8.00049M9 12L22 12M22 12L18 8M22 12L18 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.43404 1.68597C4.28969 1.25 5.40979 1.25 7.65 1.25H8.35C10.5902 1.25 11.7103 1.25 12.566 1.68597C13.3186 2.06947 13.9305 2.68139 14.314 3.43404C14.75 4.28968 14.75 5.40979 14.75 7.65V11.2501H8C7.58579 11.2501 7.25 11.5859 7.25 12.0001C7.25 12.4143 7.58579 12.7501 8 12.7501H14.75V16.35C14.75 18.5902 14.75 19.7103 14.314 20.566C13.9305 21.3186 13.3186 21.9305 12.566 22.314C11.7103 22.75 10.5902 22.75 8.35 22.75H7.65C5.40979 22.75 4.28969 22.75 3.43404 22.314C2.68139 21.9305 2.06947 21.3186 1.68598 20.566C1.25 19.7103 1.25 18.5902 1.25 16.35L1.25 7.65C1.25 5.40979 1.25 4.28968 1.68598 3.43404C2.06947 2.68139 2.68139 2.06947 3.43404 1.68597ZM14.75 12.7501L20.1895 12.7501L17.4698 15.4698C17.1769 15.7626 17.1769 16.2375 17.4698 16.5304C17.7627 16.8233 18.2376 16.8233 18.5305 16.5304L22.5305 12.5304C22.8233 12.2375 22.8233 11.7626 22.5305 11.4698L18.5305 7.46975C18.2376 7.17686 17.7627 7.17686 17.4698 7.46975C17.1769 7.76264 17.1769 8.23752 17.4698 8.53041L20.1895 11.2501L14.75 11.2501V12.7501Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14.0001 16.0005L14.0001 16.5V16.5C14.0001 17.896 14.0001 18.594 13.8278 19.1619C13.4399 20.4401 12.4397 21.4403 11.1615 21.8281C10.5936 22.0005 9.89561 22.0005 8.49963 22.0005H8.00009C6.13636 22.0005 5.20449 22.0005 4.46942 21.696C3.48928 21.29 2.71057 20.5113 2.30459 19.5312C2.00012 18.7961 2.00012 17.8643 2.00012 16.0005L2.00013 14.5L2 14M14.0001 8.00049L14.0001 7.5V7.5C14.0001 6.10489 14.0001 5.40734 13.828 4.83972C13.4402 3.56101 12.4396 2.56037 11.1609 2.17262C10.5933 2.00049 9.89572 2.00049 8.50061 2.00049L8.00012 2.00049C6.13636 2.00049 5.20448 2.00049 4.46939 2.30497C3.48928 2.71095 2.71058 3.48964 2.30461 4.46975C2.00013 5.20484 2.00013 6.13672 2.00013 8.00049L2.00013 9.5L2 10M9 12L22 12L18 8M19.5 14.5L18 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M14 16.0005L13.9999 16.5V16.5C14 17.896 14 18.594 13.8276 19.1619C13.4398 20.4401 12.4396 21.4403 11.1614 21.8281C10.5935 22.0005 9.89549 22.0005 8.49951 22.0005H7.99997C6.13623 22.0005 5.20436 22.0005 4.46929 21.696C3.48916 21.29 2.71045 20.5113 2.30447 19.5312C2 18.7961 2 17.8643 2 16.0005L2 8.00049C2 6.13672 2 5.20484 2.30448 4.46975C2.71046 3.48964 3.48916 2.71095 4.46927 2.30497C5.20435 2.00049 6.13624 2.00049 8 2.00049L8.50049 2.00049C9.8956 2.00049 10.5931 2.00049 11.1608 2.17262C12.4395 2.56037 13.4401 3.56101 13.8279 4.83972C14 5.40734 14 6.10489 14 7.5V7.5L14 8.00049M9 12L22 12M22 12L18 8M22 12L18 16"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M7.65 1.25C5.40979 1.25 4.28969 1.25 3.43404 1.68597C2.68139 2.06947 2.06947 2.68139 1.68597 3.43404C1.25 4.28969 1.25 5.40979 1.25 7.65V16.35C1.25 18.5902 1.25 19.7103 1.68597 20.566C2.06947 21.3186 2.68139 21.9305 3.43404 22.314C4.28969 22.75 5.40979 22.75 7.65 22.75H8.35C10.5902 22.75 11.7103 22.75 12.566 22.314C13.3186 21.9305 13.9305 21.3186 14.314 20.566C14.75 19.7103 14.75 18.5902 14.75 16.35V7.65C14.75 5.40979 14.75 4.28969 14.314 3.43404C13.9305 2.68139 13.3186 2.06947 12.566 1.68597C11.7103 1.25 10.5902 1.25 8.35 1.25H7.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.4698 7.46973C17.7627 7.17684 18.2376 7.17684 18.5305 7.46973L22.5305 11.4697C22.8233 11.7626 22.8233 12.2375 22.5305 12.5304L18.5305 16.5304C18.2376 16.8233 17.7627 16.8233 17.4698 16.5304C17.1769 16.2375 17.1769 15.7626 17.4698 15.4697L20.1895 12.7501L8 12.7501C7.58579 12.7501 7.25 12.4143 7.25 12.0001C7.25 11.5858 7.58579 11.2501 8 11.2501L20.1895 11.2501L17.4698 8.53039C17.1769 8.2375 17.1769 7.76262 17.4698 7.46973Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
